import { ReactNode } from "react";
import "./RichTextEditorDialogActions.css";

type Props = Readonly<{
  "data-test-id"?: string;
  children: ReactNode;
}>;

export function RichTextEditorDialogButtonsList({
  children
}: Props): JSX.Element {
  return <div className="DialogButtonsList">{children}</div>;
}

export function RichTextEditorDialogActions({
  "data-test-id": dataTestId,
  children
}: Props): JSX.Element {
  return (
    <div className="DialogActions" data-test-id={dataTestId}>
      {children}
    </div>
  );
}
